import { firebaseApp } from './Firebase'
import 'firebase/remote-config'

export enum ConfigValue {
  appConfigHost = 'app_config_host',
  deepLinkDomain = 'deep_link_domain',
  deepLinkItem = 'deep_link_item',
  shareAndroidPackage = 'share_android_package',
  shareIOSId = 'share_ios_id',
  shareIOSPackage = 'share_ios_package',
  shopifyApiBaseUrl = 'shopify_api_base_url',
  shopifyApiToken = 'shopify_api_token',
  defaultDynamicLink = 'default_dynamic_link'
}

export const utmAppname = 'moinmoin' // Google Campaign source
export const dynamicLinksService = 'https://dynamic-links.live.moinmoin.io'
export const remoteConfig = firebaseApp.remoteConfig()
remoteConfig.settings.minimumFetchIntervalMillis = 30000 // 3600000

// staging:
// remoteConfig.defaultConfig = {
//   app_config_host: 'https://staging.moinmoin.io',
//   deep_link_domain: 'https://share.moinmoin.io',
//   deep_link_item: 'https://moinmoin.io/detail/{itemId}',
//   share_android_package: 'io.moinmoin',
//   share_ios_id: '6443877715',
//   share_ios_package: 'io.moinmoin',
//   shopify_api_base_url: 'https://spruche-app-de.myshopify.com',
//   shopify_api_token: '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',
//   default_dynamic_link: 'https://share.staging.moinmoin.io/getApp'
// }

// live:
remoteConfig.defaultConfig = {
  app_config_host: 'https://live.moinmoin.io',
  deep_link_domain: 'https://vonherzen.moinmoin.io',

  // The following values don't exist in firebase anymore
  deep_link_item: 'https://moinmoin.io/detail/{itemId}',
  share_android_package: 'io.moinmoin',
  share_ios_id: 'id6443877715',
  share_ios_package: 'io.moinmoin',
  shopify_api_base_url: 'https://spruche-app-de.myshopify.com',
  shopify_api_token: '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',
  default_dynamic_link: 'https://vonherzen.moinmoin.io'
}

remoteConfig.fetchAndActivate()
